<div class="position-relative">
  <input
    type="text"
    #customDateInput
    #popover="ngbPopover"
    autocomplete="off"
    class="datepicker-input"
    [disabled]="disabled"
    [class.disabled]="disabled"
    [class.calendar-open]="showingDatePicker$ | async"
    [class.form-error-border]="error"
    [attr.id]="controlId"
    [value]="displayValue$ | async"
    [container]="'body'"
    [triggers]="'manual'"
    [animation]="false"
    [autoClose]="false"
    [ngbPopover]="datePicker"
    [popoverClass]="'date-picker-popover'"
    [maskito]="maskitoOptions"
    [placeholder]="placeholder"
    (input)="onInput($event)"
    (blur)="onBlur()"
    (focus)="onFocus()" />
  <button
    type="button"
    class="no-style-button datepicker-input-button"
    [disabled]="disabled"
    (click)="openDatePicker()">
    <img [src]="inputIconSrc$ | async" alt="open datepicker" i18n-alt />
  </button>
</div>

<input
  #nativeDateInput
  class="visually-hidden"
  type="date"
  [disabled]="disabled"
  [min]="minDate$ | async"
  [max]="maxDate$ | async"
  [value]="nativeInputValue$ | async"
  (focus)="inputFocused.emit()"
  (change)="onNativeInputChange($event)" />

<ng-template #datePicker>
  <app-datepicker-input-calendar
    [dateRange]="isUsingRange$ | async"
    [isStartDate]="isStartDate"
    [initialSelectedDates]="selectedFormattedDates$ | async"
    [minDate]="minDate$ | async"
    [maxDate]="maxDate$ | async"
    (dateSelected)="onDateSelected($event)" />
</ng-template>
